export default __webpack_public_path__ + "static/media/Untitled design (17).c2abb8be.webp";